document.addEventListener("DOMContentLoaded", () => {
  $(document).on("click", "li.has-sub-child-menu", function (e) {
    if ($(this).hasClass("active_link")) {
      $(this).parent().find("li.has-sub-child-menu").removeClass("active_link");
    } else {
      $(this).parent().find("li.has-sub-child-menu").removeClass("active_link");
      $(this).addClass("active_link");
    }

    $(this)
      .parent()
      .find(
        "div.has-sub-child[data-childof='" + $(this).attr("data-childof") + "']"
      )
      .toggleClass("hide");
    $(this)
      .parent()
      .find(
        "div.has-sub-child[data-childof='" +
          $(this).attr("data-childof") +
          "'] ul"
      )
      .toggleClass("ms_submenu_open");
    e.preventDefault();
  });

  $(document).on("click", "ul.new_nav li.parent_menu_link", function (e) {
    console.log($(this).attr("data-mainMenufor"));

    $("ul.new_nav li.parent_menu_link").removeClass("active_link");
    $(this).addClass("active_link");

    if ($("div#" + $(this).attr("data-mainMenufor")).hasClass("hide")) {
      $(".drawer-custom-submneu").addClass("hide");
      $("div#" + $(this).attr("data-mainMenufor")).removeClass("hide");
    }
    // $("div#"+$(this).attr("data-mainMenufor")).toggleClass("hide");
    e.preventDefault();
  });

  document
    .querySelectorAll(".header__submenu summary.header__menu-item")
    .forEach((summary) => {
      summary.addEventListener("click", (event) => {
        [
          ...document.querySelectorAll(
            ".header__submenu summary.header__menu-item"
          ),
        ]
          .filter((el) => el !== event.target)
          .forEach((el) => el.parentElement.removeAttribute("open"));
      });
    });

  document.querySelectorAll(".custom-carrousel__buttons").forEach((button) => {
    button.addEventListener("click", (event) => {
      [...document.querySelectorAll(".custom-carrousel__buttons .btn-nude")]
        .filter((el) => el !== event.target)
        .forEach((el) => el.classList.remove("active"));
      event.target.classList.add("active");
      document
        .getElementById(event.target.dataset.target)
        .closest(".custom-carrousel__content")
        .querySelector(".active")
        .classList.remove("active");
      document
        .getElementById(event.target.dataset.target)
        .classList.add("active");
    });
  });
});
